import { Component, inject, signal } from '@angular/core';
import { COMMON_IMPORTS } from '../../../../Shared/common-imports';
import { AvThemeToggleComponent } from '../../../../Shared/Components/theme-toggle/theme-toggle.component';
import { environment } from '../../../../../../environments/environment';
import { NavigationService, NavItem } from '../../../Services/navigation.service';

@Component({
  selector: 'app-primary-nav',
  imports: [...COMMON_IMPORTS, AvThemeToggleComponent],
  templateUrl: './primary-nav.component.html',
  styleUrls: ['./primary-nav.component.scss'],
})
export class PrimaryNavComponent {
  navigationService = inject(NavigationService);
  itemHeight: number = 50;
  activeIndex = signal<number>(0);
  version = environment.version;

  onActiveChange(isActive: boolean, index: number, item: NavItem): void {
    if (isActive) {
      this.activeIndex.set(index);
      this.navigationService.setActiveItem(item)
    }
  }
}
